export const navText = {
    heading: {
        en: 'Discover our Products',
        fr: 'Decouvrez nos Produits',
    },
    sub: {
        en: 'You can navigate our products with the below interactive mannequin',
        fr: 'Vous pouvez utiliser le mannequin interactif pour naviguer nos produits',
    }
};

export const buttonText = {
    video: {
        en: 'Measurement Video',
        fr: 'Vidéo de mesures',
    },
    measurement: {
        en: 'Measurement Form',
        fr: 'Formulaire de mesures',
    },
    order: {
        en: 'Order Form',
        fr: 'Formulaire de commandes',
    }
}